import React from 'react';
import {Link} from 'react-router';
import {List} from 'immutable';
import classNames from 'classnames';
import './ManagerTeamRankableThings.styl';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import {getCoachRepLink} from 'components/dashboard/coach/CoachSummaryDashboard';
import {TOOLTIP_DELAY} from 'components/StatsPage2.utils';

class ManagerTeamRankableThings extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isUp: true,
    };
    this.toggleSortDirection = this.toggleSortDirection.bind(this);
  }

  toggleSortDirection() {
    this.setState({isUp: !this.state.isUp});
  }

  sortByValueAndAddRanks(repValues, directReports) {
    const list = List(repValues);
    const sorted = list.sort((a, b) => {
      // nulls need to rank last, so we say they are the smallest
      if (a.value == null && b.value) {
        return -1;
      }
      if (a.value && b.value == null) {
        return 1;
      }
      if (a.value == null && b.value == null) {
        return 0;
      }
      if (a.value !== b.value) {
        return a.value - b.value;
      }
      const aUser = directReports.get(a.repId);
      const bUser = directReports.get(b.repId);
      // should not happen, but if does, whatever
      if (!aUser || !bUser) {
        return a.repId.localeCompare(b.repId);
      }
      if (aUser.firstName && bUser.firstName && aUser.firstName !== bUser.firstName) {
        // reversed string comparison, so Aaron goes before Zach
        return bUser.firstName.localeCompare(aUser.firstName);
      }
      if (aUser.lastName && bUser.lastName && aUser.lastName !== bUser.lastName) {
        return bUser.lastName.localeCompare(aUser.lastName);
      }
      // seriously?? whatever
      return a.repId.localeCompare(b.repId);
    });
    const sortedWithLargerIsBetterAdjustment = this.props.largerIsBetter
      ? sorted.reverse()
      : sorted;
    const ranked = sortedWithLargerIsBetterAdjustment.map((it, i) => {
      const rank = i + 1;
      return Object.assign({rank}, it);
    });
    return this.state.isUp ? ranked : ranked.reverse();
  }

  renderRep(repValue, prevRank) {
    const {directReports} = this.props;
    const rep = directReports.get(repValue.repId);
    if (!directReports.get(repValue.repId)) {
      console.error(repValue.repId, 'is not a direct report of manager ', this.props.managerId);
      return null;
    }
    const compareLast = prevRank != null ? prevRank - repValue.rank : null;
    const compareLastLabel =
      compareLast != null
        ? compareLast === 0
          ? '='
          : compareLast > 0
          ? `+${compareLast}`
          : compareLast
        : '';
    const compareLastUpDown =
      compareLast != null ? (compareLast > 0 ? 'up' : compareLast < 0 ? 'down' : 'equal') : '';
    return (
      <div className="rep-rank-row" key={repValue.repId}>
        <div className={classNames('rep-rank', this.state.isUp ? 'up' : 'down')}>
          {repValue.rank}
        </div>
        <div className="compare-last">
          <div className={classNames('arrow', compareLastUpDown)}></div>
          <div className={classNames('label', compareLastUpDown)}>{compareLastLabel}</div>
        </div>
        {this.getRepLink(repValue, rep)}
      </div>
    );
  }

  getRepLink(repValue, rep) {
    const {directReports} = this.props;
    const link = getCoachRepLink({rep}, this.props, null, true);
    return (
      <Link
        to={{
          pathname: link.pathname,
          query: link?.query,
          state: link.state,
        }}
        className={classNames('rep-name', repValue.value ? '' : 'nil-value')}>
        {directReports.get(repValue.repId).getFullName()}
      </Link>
    );
  }

  render() {
    const {title, repValues, prevRepValues, directReports, topN, link, showLink} = this.props;
    // showLink defaults to true
    // directReports may not be set yet on initial render
    if (!directReports || directReports.isEmpty()) return null;
    const sortedAndLimited = repValues
      ? this.sortByValueAndAddRanks(repValues, directReports).take(topN)
      : null;
    const prevRanksMap = {};
    if (prevRepValues) {
      const prevRanks = this.sortByValueAndAddRanks(prevRepValues, directReports);
      prevRanks.forEach(ranked => {
        prevRanksMap[ranked.repId] = ranked.rank;
      });
    }
    return (
      <div className="manager-team-rankable-thing">
        <GenericTooltip tooltip={this.props.tooltip} positionTop delay={TOOLTIP_DELAY}>
          <div
            className="rankable-title-row"
            onMouseEnter={this.props.onMouseEnter}
            onMouseLeave={this.props.onMouseLeave}>
            <div className="rankable-title">{title}</div>
            <div className="rankable-arrows" onClick={this.toggleSortDirection}>
              <div
                className={classNames([
                  'rank-arrow',
                  'arrow-up',
                  this.state.isUp ? 'up-selected' : null,
                ])}
              />
              <div
                className={classNames([
                  'rank-arrow',
                  'arrow-down',
                  this.state.isUp ? null : 'down-selected',
                ])}
              />
            </div>
          </div>
        </GenericTooltip>
        <div className="rankable-body">
          {sortedAndLimited &&
            sortedAndLimited.map(repValue =>
              this.renderRep(repValue, prevRanksMap[repValue.repId])
            )}
        </div>
        {showLink !== false && (
          <Link className="generic-link rankable-link" to={link}>
            show more
          </Link>
        )}
      </div>
    );
  }
}

export default ManagerTeamRankableThings;
